import styled, { css } from 'styled-components'
import propsToCSS from 'utils/styling/propsToCSS'
import elements from 'styles/elements'
import sizing from 'styles/sizing'
import spacing from 'styles/spacing'
import type { IconButtonStyledProps } from 'types/iconButton'

const propStyles = {
  default: elements.default,
  primary: elements.primary,
  secondary: elements.secondary,
  outline: elements.outline,
  destructive: elements.destructive,
} as const

/**
 * Styled button component that combines multiple style functions:
 * elements, sizing, spacing, and propsToCSS.
 */
export const Button = styled.button<IconButtonStyledProps>(
  ({ ...props }) => css`
    display: flex;
    align-items: center;
    user-select: none;
    cursor: pointer;
    white-space: nowrap;

    ${propsToCSS(props, propStyles)}
    ${sizing(props)}
    ${spacing(props)}

    border: none;
    background: none;
    padding: 0;
    width: auto;
    height: auto;
    min-width: 40px;
    min-height: 40px;
    font-size: inherit;
    font-weight: inherit;
    box-shadow: none;
    justify-content: center;

    & > svg {
      font-size: 24px;
      width: 32px;
      height: 32px;
    }
  `,
)
